export default "__VITE_ASSET__D$t4fSJG__"